// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1prNn","title":"InfoRow_title__1gNXN"};